import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { IconType, Button, TextButton, IconButton, ButtonType } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import styles from '../domainManager/style.scss';
import ErrorDialog from '../../portal/dialogs/errorDialog';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../services/ui/toastrService';
import erorrHandler from '../../../services/web/erorrHandler';
import RemoveDomainButton from './removeDomainButton';

@inject('translationsStore', 'windowsDomainsStore') @observer
export default class DomainActions extends Component {

    state = {
        openDeleteDialog: false,
        openErrorDialog: false
    };

    openErrorDialog = () => {

        this.setState({
            openErrorDialog: true
        });
    }

    closeErrorDialog = () => {

        this.setState({
            openErrorDialog: false
        });
    }

    editDomain = () => {

        this.props.windowsDomainsStore.chooseDomainForEdit(this.props.id);
    }

    openDeleteDialog = () => {

        this.setState({
            openDeleteDialog: true
        });
    }

    closeDeleteDialog = () => {

        this.setState({
            openDeleteDialog: false
        });
    }

    removeDomain = () => {

        this.props.windowsDomainsStore.deleteDomain(this.props.id)
            .then(() => {

                this.closeDeleteDialog();
                var level = ToastrLevelsEnum.SUCCESS;
                var message = this.props.translationsStore.translate('DOMAIN_DELETE_SUCCESS_MESSAGE');
                ToastrService.triggerToastr({ level, message });

            })
            .catch((error) => {
                this.errorDialogMessage = erorrHandler.getErrorMessage(error);
                this.openErrorDialog();
            });
    }

    cancelEdit = () => this.props.windowsDomainsStore.cancelEdit();
    
    cancelAdd = () => this.props.windowsDomainsStore.cancelAdd();

    saveEditDomain = () => {

        const { domainDnsValidationMessage, domainValidationMessage } = this.props.windowsDomainsStore;
        if (domainDnsValidationMessage || domainValidationMessage) return;
        this.props.windowsDomainsStore.editDomain()
            .then(() => {
                var level = ToastrLevelsEnum.SUCCESS;
                var message = this.props.translationsStore.translate('DOMAIN_UPDATE_SUCCESS_MESSAGE');
                ToastrService.triggerToastr({ level, message });
            })
            .catch((error) => {

                this.errorDialogMessage = erorrHandler.getErrorMessage(error);
                this.openErrorDialog();
            });
    }

    saveAddDomain = () => {

        const { domainDnsValidationMessage, domainValidationMessage } = this.props.windowsDomainsStore;
        if (domainDnsValidationMessage || domainValidationMessage) return;
        this.props.windowsDomainsStore.addDomain()
            .then(() => {

                var level = ToastrLevelsEnum.SUCCESS;
                var message = this.props.translationsStore.translate('DOMAIN_ADD_SUCCESS_MESSAGE');
                ToastrService.triggerToastr({ level, message });
            })
            .catch((error) => {

                this.errorDialogMessage = erorrHandler.getErrorMessage(error);
                this.openErrorDialog();
            });
        ;
    }

    render() {

        const { chosenId, deleteDomain, getAllDomains } = this.props.windowsDomainsStore;
        const { name } = this.props.windowsDomainsStore.getDomainById(this.props.id);
        const isNewDomain = chosenId === -1;

        return (
            chosenId === this.props.id ?
                <div className={classNames(styles.domainActionsOpen)}>
                    <Button
                        dataCy='update-button'
                        disabled={this.props.windowsDomainsStore.editDomainProgress}
                        inProgress={this.props.windowsDomainsStore.editDomainProgress}
                        text={this.props.translationsStore.translate(isNewDomain ? 'ADD' : 'SAVE')}
                        onClick={isNewDomain ? this.saveAddDomain : this.saveEditDomain}
                    />
                    <IconButton
                        iconType={IconType.close}
                        onClick={isNewDomain ? this.cancelAdd : this.cancelEdit}
                        className={classNames(styles.actionIcons)}
                    />
                    <ErrorDialog
                        show={this.state.openErrorDialog}
                        onConfirm={this.closeErrorDialog}
                        deleteButtonText={this.props.translationsStore.translate('CLOSE')}
                        closeDeleteDialog={this.closeErrorDialog}
                        titleText={this.props.translationsStore.translate('ERROR')}
                        contentText={this.errorDialogMessage}
                    />
                </div> :
                <div className={classNames(styles.domainActions)}>
                    <TextButton
                        iconType={IconType.edit}
                        onClick={this.editDomain}
                        text={''}
                        linkClassName={classNames(styles.actionIcons)}
                        dataCy={`edit-domain_${name}`}
                   />
                    <RemoveDomainButton
                        id={this.props.id}
                        name={name}
                        translations={{
                            DOMAIN_WILL_REMOVE: this.props.translationsStore.translate('DOMAIN_WILL_REMOVE'),
                            DELETING_DOMAIN_CONFIRM_WILL_DELETE_USER: this.props.translationsStore.translate('DELETING_DOMAIN_CONFIRM_WILL_DELETE_USER'),
                            REMOVE: this.props.translationsStore.translate('REMOVE'),
                            REMOVE_DOMAIN: this.props.translationsStore.translate('REMOVE_DOMAIN'),
                            ERROR: this.props.translationsStore.translate('ERROR'),
                            CLOSE: this.props.translationsStore.translate('CLOSE'),
                            CANCEL: this.props.translationsStore.translate('CANCEL'),
                            DOMAIN_DELETE_SUCCESS_MESSAGE: this.props.translationsStore.translate('DOMAIN_DELETE_SUCCESS_MESSAGE')
                        }}
                        deleteDomain={deleteDomain.bind(this.props.windowsDomainsStore)}
                    />
                </div>
        );
    }
}